module.exports = __webpack_public_path__ + "img/11_84.ca477f6a.png";